export enum ProductCode {
  GBTL = 'GBTL',
  GBAD = 'GBAD',
  GRAD = 'GRAD',
  GRHC = 'GRHC'
}
